import type { SubscriptionListDTO } from '@telecom/shared/domain/permission/apis/stripe-api';

export const SubscriptionInfoService = Symbol.for('SubscriptionInfoService');

/**
 * 订阅信息服务
 * 负责获取和管理用户订阅信息
 */
export interface SubscriptionInfoService {
    /**
     * 获取当前有效订阅
     * @returns 当前有效的订阅信息，如果没有则返回 null
     */
    getCurrentSubscription(): Promise<SubscriptionListDTO | null>;
}
